const getOptions = (data, labelKey, detailsKey, tagHandler, disableHandler) => {
  if (data == null) return [];
  if (!Array.isArray(data)) return [];
  return data.map((item, idx) => {
    let result = {
      label: item[labelKey],
      id: item.id || idx,
    };
    if (detailsKey != null) {
      result.details = item[detailsKey];
    }
    if (typeof tagHandler === "function") {
      const tag = tagHandler(item);
      if (tag != null) {
        result.tag = tag;
      }
    }
    if (typeof disableHandler === "function") {
      const disabled = disableHandler(item);
      if (disabled === true) {
        result.disabled = true;
      }
    }
    return result;
  });
};

export default getOptions;
